'use client';

import '@/styles/components/Сertificate.css'
const Certificate = '/assets/Certificate.jpg'

import Image from 'next/image'

const Сertificate = () => {
    // Заборона правого кліка на зображенні
    const handleContextMenu = (e) => {
        e.preventDefault();
        return false;
    };

    // Заборона перетягування зображення
    const handleDragStart = (e) => {
        e.preventDefault();
        return false;
    };

    return (
        <>
            <h2 className='certificate-title'>Те, що важко отримати</h2>
            <div className="certificate__container">
                <div className="certificate__container--description">
                    <h3>Сертифікат SkyLang</h3>
                    <p>Сертифікат, який відкриває двері: підвищує шанси при вступі до університету та працевлаштуванні в Польщі.</p>
                    <p>Після курсу — не просто знання, а підтверджений результат, який цінують роботодавці та університети.</p>
                </div>
                <div className="certificate__container--img">
                    <Image
                        src={Certificate}
                        width={540}
                        height={381}
                        alt="Сертифікат SkyLang"
                        onContextMenu={handleContextMenu}
                        onDragStart={handleDragStart}
                        style={{
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none',
                            pointerEvents: 'auto'
                        }}
                        unoptimized={false}
                        priority={false}
                    />
                </div>
            </div>
        </>
    )
}

export default Сertificate